import { cn } from '@/utils'

export const HighlighterIcon = ({
  color,
  className,
}: {
  color: string
  className?: string
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('stroke-gray-800', className)}
    >
      <path
        d="M9 11L3 17V20H12L15 17"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.9998 12L17.3998 16.6C17.026 16.9665 16.5233 17.1717 15.9998 17.1717C15.4763 17.1717 14.9737 16.9665 14.5998 16.6L9.39984 11.4C9.03339 11.0261 8.82812 10.5235 8.82812 10C8.82812 9.47649 9.03339 8.97386 9.39984 8.6L13.9998 4"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
